/**
 * Messages API endpoints
 */
import { apiClient } from '../api-client';
import {
  Message,
  Conversation,
} from '@/types/message';
import { PaginationParams } from '@/types/common';

export const messagesAPI = {
  /**
   * Get all conversations for the current user
   */
  getConversations: (filters?: Partial<PaginationParams>) =>
    apiClient.get<{
      conversations: Conversation[];
      total: number;
    }>('/api/messages/conversations', { params: filters }),

  /**
   * Get messages in a specific conversation
   */
  getMessages: (conversationId: string, filters?: Partial<PaginationParams>) =>
    apiClient.get<{
      messages: Message[];
      total: number;
    }>(`/api/messages/conversations/${conversationId}/messages`, {
      params: filters,
    }),

  /**
   * Send a message
   */
  sendMessage: (conversationId: string, content: string) =>
    apiClient.post<Message>(`/api/messages/conversations/${conversationId}/messages`, {
      content,
    }),

  /**
   * Create a new conversation
   */
  createConversation: (recipientId: string, initialMessage?: string) =>
    apiClient.post<Conversation>('/api/messages/conversations', {
      recipientId,
      initialMessage,
    }),

  /**
   * Get a single conversation
   */
  getConversation: (conversationId: string) =>
    apiClient.get<Conversation>(`/api/messages/conversations/${conversationId}`),

  /**
   * Mark messages as read
   */
  markAsRead: (conversationId: string) =>
    apiClient.post<{ success: boolean }>(
      `/api/messages/conversations/${conversationId}/mark-read`,
      {}
    ),

  /**
   * Delete a conversation
   */
  deleteConversation: (conversationId: string) =>
    apiClient.delete<{ success: boolean }>(`/api/messages/conversations/${conversationId}`),

  /**
   * Get unread message count
   */
  getUnreadCount: () =>
    apiClient.get<{ unreadCount: number }>('/api/messages/unread-count'),
};

